<div class="container">
  <div class="container-table">
    <header class="top-header">
      <h3>Register Entries</h3>
      <p>Review and manage submissions</p>
    </header>

    <div class="entries-controls">
      <div class="search-bar wide-search-bar entries-search">
        <app-generic-search
          [apiUrl]="'visitor-management/entries'"
          [resultsApiUrl]="'visitor-management/entries'"
          [apiBaseUrl]="visitorApiBaseUrl"
          [method]="'GET'"
          [searchParamName]="'search'"
          [extraBody]="searchExtras"
          [pageSize]="recordsPerPage"
          [minChars]="2"
          (resultsFetched)="onResults($event)">
        </app-generic-search>
      </div>
      <div class="filters-grid" [formGroup]="filtersForm">
        <div class="form-item">
          <label>From</label>
          <p-datepicker
            formControlName="fromDate"
            dateFormat="dd/mm/yy"
            [showIcon]="true"
            [showOnFocus]="true"
            [showButtonBar]="true"
            [readonlyInput]="true">
          </p-datepicker>
        </div>
        <div class="form-item">
          <label>To</label>
          <p-datepicker
            formControlName="toDate"
            dateFormat="dd/mm/yy"
            [showIcon]="true"
            [showOnFocus]="true"
            [showButtonBar]="true"
            [readonlyInput]="true">
          </p-datepicker>
        </div>
        <div class="form-item">
          <label>Register</label>
          <select formControlName="register_id" (change)="applyFilters()">
            <option value="">All</option>
            <option *ngFor="let register of registers" [value]="register.id">{{ register.name }}</option>
          </select>
        </div>
        <div class="form-item">
          <label>Location</label>
          <select formControlName="location_id" (change)="applyFilters()">
            <option value="">All</option>
            <option *ngFor="let location of locations" [value]="location.id">
              {{ location.village_or_locality_name }} - {{ location.district_name }}
            </option>
          </select>
        </div>
        <div class="form-item">
          <label>Status</label>
          <select formControlName="status" (change)="applyFilters()">
            <option value="">All</option>
            <option value="draft">Draft</option>
            <option value="submitted">Submitted</option>
            <option value="under_review">Under Review</option>
            <option value="approved">Approved</option>
            <option value="rejected">Rejected</option>
          </select>
        </div>
        <div class="form-item actions">
          <button
            type="button"
            class="btn-action btn-entry"
            (click)="loadMoreLocations()"
            *ngIf="hasMoreLocations">
            More
          </button>
          <button class="btn-action btn-entry" type="button" (click)="applyFilters()">Apply</button>
        </div>
      </div>
    </div>

    <div class="responsive-table-wrapper">
      <table class="entries-table">
        <thead>
          <tr>
            <th>Date</th>
            <th>Register Name</th>
            <th>Location</th>
            <th>Status</th>
            <th>Created By</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let entry of entries">
            <td>{{ entry.created_at | date: 'dd-MM-yyyy hh:mm a' }}</td>
            <td>{{ getRegisterName(entry.register) }}</td>
            <td>{{ getLocationLabel(entry.location) }}</td>
            <td>{{ entry.status }}</td>
            <td>{{ entry.created_by?.username || entry.created_by || '-' }}</td>
            <td>
              <button class="action-button bt-edit" (click)="editEntry(entry.id)" title="Edit">
                <fa-icon [icon]="['fas', 'pen']"></fa-icon>
              </button>
            </td>
          </tr>
          <tr *ngIf="entries.length === 0">
            <td colspan="6">No entries found.</td>
          </tr>
        </tbody>
      </table>

      <div class="footer entries-footer">
        <div class="total-records">Total Records: {{ totalRecords }}</div>
        <div class="pagination-controls">
          <label for="recordsPerPage">Records per page</label>
          <select id="recordsPerPage" [(ngModel)]="recordsPerPage" (change)="selectPageSize()">
              <option *ngFor="let option of pageSizeOptions" [value]="option">{{ option }}</option>
          </select>
          <span>{{ currentPage }} / {{ totalPages }}</span>
          <button (click)="previous()" class="change-page" title="Previous page">
            <fa-icon [icon]="['fas', 'angle-left']"></fa-icon>
          </button>
          <button (click)="next()" class="change-page" title="Next page">
            <fa-icon [icon]="['fas', 'angle-right']"></fa-icon>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
